module.exports = __webpack_public_path__ + "static/media/ornamental-floral-design-with-symmetry-svgrepo-com.c4aa2881.svg";